// GENERATED by scripts/gen_iso_3166.mjs — do not hand-edit.
//
// ISO 3166-1, alpha-2, with the English, French and Dutch names CLDR gives.
// 249 entries. Sorted by English name, which is the order the seed
// writes and therefore the order the dropdown shows before a firm reorders it.
//
//   code set   iso-codes 4.16.0-1  (/usr/share/iso-codes/json/iso_3166-1.json)
//   labels     CLDR via Intl.DisplayNames, ICU 78.2, Node 20.20.2
//
// The register's English and CLDR's differ for 46 entries; CLDR wins,
// because it is what a person typing their client's country expects to see
// ("Bolivia", not "Bolivia, Plurinational State of"). The generator prints the
// full list of divergences on every run.
//
// PURE DATA: no imports, no runtime. Consumed by src/utils/taxonomyMap.ts
// (KIND_TO_DEFAULT.country, and through it the taxonomy seed) and by
// server/scripts/seed_deploy_taxonomy_translations.js.

/** @type {ReadonlyArray<readonly [code: string, en: string, fr: string, nl: string]>} */
export const ISO_3166_1 = [
  ["AF", "Afghanistan", "Afghanistan", "Afghanistan"],
  ["AX", "Åland Islands", "Îles Åland", "Åland"],
  ["AL", "Albania", "Albanie", "Albanië"],
  ["DZ", "Algeria", "Algérie", "Algerije"],
  ["AS", "American Samoa", "Samoa américaines", "Amerikaans-Samoa"],
  ["AD", "Andorra", "Andorre", "Andorra"],
  ["AO", "Angola", "Angola", "Angola"],
  ["AI", "Anguilla", "Anguilla", "Anguilla"],
  ["AQ", "Antarctica", "Antarctique", "Antarctica"],
  ["AG", "Antigua & Barbuda", "Antigua-et-Barbuda", "Antigua en Barbuda"],
  ["AR", "Argentina", "Argentine", "Argentinië"],
  ["AM", "Armenia", "Arménie", "Armenië"],
  ["AW", "Aruba", "Aruba", "Aruba"],
  ["AU", "Australia", "Australie", "Australië"],
  ["AT", "Austria", "Autriche", "Oostenrijk"],
  ["AZ", "Azerbaijan", "Azerbaïdjan", "Azerbeidzjan"],
  ["BS", "Bahamas", "Bahamas", "Bahama’s"],
  ["BH", "Bahrain", "Bahreïn", "Bahrein"],
  ["BD", "Bangladesh", "Bangladesh", "Bangladesh"],
  ["BB", "Barbados", "Barbade", "Barbados"],
  ["BY", "Belarus", "Biélorussie", "Belarus"],
  ["BE", "Belgium", "Belgique", "België"],
  ["BZ", "Belize", "Belize", "Belize"],
  ["BJ", "Benin", "Bénin", "Benin"],
  ["BM", "Bermuda", "Bermudes", "Bermuda"],
  ["BT", "Bhutan", "Bhoutan", "Bhutan"],
  ["BO", "Bolivia", "Bolivie", "Bolivia"],
  ["BA", "Bosnia & Herzegovina", "Bosnie-Herzégovine", "Bosnië en Herzegovina"],
  ["BW", "Botswana", "Botswana", "Botswana"],
  ["BV", "Bouvet Island", "Île Bouvet", "Bouveteiland"],
  ["BR", "Brazil", "Brésil", "Brazilië"],
  ["IO", "British Indian Ocean Territory", "Territoire britannique de l’océan Indien", "Brits Indische Oceaanterritorium"],
  ["VG", "British Virgin Islands", "Îles Vierges britanniques", "Britse Maagdeneilanden"],
  ["BN", "Brunei", "Brunei", "Brunei"],
  ["BG", "Bulgaria", "Bulgarie", "Bulgarije"],
  ["BF", "Burkina Faso", "Burkina Faso", "Burkina Faso"],
  ["BI", "Burundi", "Burundi", "Burundi"],
  ["KH", "Cambodia", "Cambodge", "Cambodja"],
  ["CM", "Cameroon", "Cameroun", "Kameroen"],
  ["CA", "Canada", "Canada", "Canada"],
  ["CV", "Cape Verde", "Cap-Vert", "Kaapverdië"],
  ["BQ", "Caribbean Netherlands", "Pays-Bas caribéens", "Caribisch Nederland"],
  ["KY", "Cayman Islands", "Îles Caïmans", "Kaaimaneilanden"],
  ["CF", "Central African Republic", "République centrafricaine", "Centraal-Afrikaanse Republiek"],
  ["TD", "Chad", "Tchad", "Tsjaad"],
  ["CL", "Chile", "Chili", "Chili"],
  ["CN", "China", "Chine", "China"],
  ["CX", "Christmas Island", "Île Christmas", "Christmaseiland"],
  ["CC", "Cocos (Keeling) Islands", "Îles Cocos", "Cocoseilanden"],
  ["CO", "Colombia", "Colombie", "Colombia"],
  ["KM", "Comoros", "Comores", "Comoren"],
  ["CG", "Congo - Brazzaville", "Congo-Brazzaville", "Congo-Brazzaville"],
  ["CD", "Congo - Kinshasa", "Congo-Kinshasa", "Congo-Kinshasa"],
  ["CK", "Cook Islands", "Îles Cook", "Cookeilanden"],
  ["CR", "Costa Rica", "Costa Rica", "Costa Rica"],
  ["CI", "Côte d’Ivoire", "Côte d’Ivoire", "Ivoorkust"],
  ["HR", "Croatia", "Croatie", "Kroatië"],
  ["CU", "Cuba", "Cuba", "Cuba"],
  ["CW", "Curaçao", "Curaçao", "Curaçao"],
  ["CY", "Cyprus", "Chypre", "Cyprus"],
  ["CZ", "Czechia", "Tchéquie", "Tsjechië"],
  ["DK", "Denmark", "Danemark", "Denemarken"],
  ["DJ", "Djibouti", "Djibouti", "Djibouti"],
  ["DM", "Dominica", "Dominique", "Dominica"],
  ["DO", "Dominican Republic", "République dominicaine", "Dominicaanse Republiek"],
  ["EC", "Ecuador", "Équateur", "Ecuador"],
  ["EG", "Egypt", "Égypte", "Egypte"],
  ["SV", "El Salvador", "Salvador", "El Salvador"],
  ["GQ", "Equatorial Guinea", "Guinée équatoriale", "Equatoriaal-Guinea"],
  ["ER", "Eritrea", "Érythrée", "Eritrea"],
  ["EE", "Estonia", "Estonie", "Estland"],
  ["SZ", "Eswatini", "Eswatini", "Eswatini"],
  ["ET", "Ethiopia", "Éthiopie", "Ethiopië"],
  ["FK", "Falkland Islands", "Îles Malouines", "Falklandeilanden"],
  ["FO", "Faroe Islands", "Îles Féroé", "Faeröer"],
  ["FJ", "Fiji", "Fidji", "Fiji"],
  ["FI", "Finland", "Finlande", "Finland"],
  ["FR", "France", "France", "Frankrijk"],
  ["GF", "French Guiana", "Guyane française", "Frans-Guyana"],
  ["PF", "French Polynesia", "Polynésie française", "Frans-Polynesië"],
  ["TF", "French Southern Territories", "Terres australes françaises", "Franse Gebieden in de zuidelijke Indische Oceaan"],
  ["GA", "Gabon", "Gabon", "Gabon"],
  ["GM", "Gambia", "Gambie", "Gambia"],
  ["GE", "Georgia", "Géorgie", "Georgië"],
  ["DE", "Germany", "Allemagne", "Duitsland"],
  ["GH", "Ghana", "Ghana", "Ghana"],
  ["GI", "Gibraltar", "Gibraltar", "Gibraltar"],
  ["GR", "Greece", "Grèce", "Griekenland"],
  ["GL", "Greenland", "Groenland", "Groenland"],
  ["GD", "Grenada", "Grenade", "Grenada"],
  ["GP", "Guadeloupe", "Guadeloupe", "Guadeloupe"],
  ["GU", "Guam", "Guam", "Guam"],
  ["GT", "Guatemala", "Guatemala", "Guatemala"],
  ["GG", "Guernsey", "Guernesey", "Guernsey"],
  ["GN", "Guinea", "Guinée", "Guinee"],
  ["GW", "Guinea-Bissau", "Guinée-Bissau", "Guinee-Bissau"],
  ["GY", "Guyana", "Guyana", "Guyana"],
  ["HT", "Haiti", "Haïti", "Haïti"],
  ["HM", "Heard & McDonald Islands", "Îles Heard-et-MacDonald", "Heard en McDonaldeilanden"],
  ["HN", "Honduras", "Honduras", "Honduras"],
  ["HK", "Hong Kong SAR China", "R.A.S. chinoise de Hong Kong", "Hongkong SAR van China"],
  ["HU", "Hungary", "Hongrie", "Hongarije"],
  ["IS", "Iceland", "Islande", "IJsland"],
  ["IN", "India", "Inde", "India"],
  ["ID", "Indonesia", "Indonésie", "Indonesië"],
  ["IR", "Iran", "Iran", "Iran"],
  ["IQ", "Iraq", "Irak", "Irak"],
  ["IE", "Ireland", "Irlande", "Ierland"],
  ["IM", "Isle of Man", "Île de Man", "Isle of Man"],
  ["IL", "Israel", "Israël", "Israël"],
  ["IT", "Italy", "Italie", "Italië"],
  ["JM", "Jamaica", "Jamaïque", "Jamaica"],
  ["JP", "Japan", "Japon", "Japan"],
  ["JE", "Jersey", "Jersey", "Jersey"],
  ["JO", "Jordan", "Jordanie", "Jordanië"],
  ["KZ", "Kazakhstan", "Kazakhstan", "Kazachstan"],
  ["KE", "Kenya", "Kenya", "Kenia"],
  ["KI", "Kiribati", "Kiribati", "Kiribati"],
  ["KW", "Kuwait", "Koweït", "Koeweit"],
  ["KG", "Kyrgyzstan", "Kirghizstan", "Kirgizië"],
  ["LA", "Laos", "Laos", "Laos"],
  ["LV", "Latvia", "Lettonie", "Letland"],
  ["LB", "Lebanon", "Liban", "Libanon"],
  ["LS", "Lesotho", "Lesotho", "Lesotho"],
  ["LR", "Liberia", "Liberia", "Liberia"],
  ["LY", "Libya", "Libye", "Libië"],
  ["LI", "Liechtenstein", "Liechtenstein", "Liechtenstein"],
  ["LT", "Lithuania", "Lituanie", "Litouwen"],
  ["LU", "Luxembourg", "Luxembourg", "Luxemburg"],
  ["MO", "Macao SAR China", "R.A.S. chinoise de Macao", "Macau SAR van China"],
  ["MG", "Madagascar", "Madagascar", "Madagaskar"],
  ["MW", "Malawi", "Malawi", "Malawi"],
  ["MY", "Malaysia", "Malaisie", "Maleisië"],
  ["MV", "Maldives", "Maldives", "Maldiven"],
  ["ML", "Mali", "Mali", "Mali"],
  ["MT", "Malta", "Malte", "Malta"],
  ["MH", "Marshall Islands", "Îles Marshall", "Marshalleilanden"],
  ["MQ", "Martinique", "Martinique", "Martinique"],
  ["MR", "Mauritania", "Mauritanie", "Mauritanië"],
  ["MU", "Mauritius", "Maurice", "Mauritius"],
  ["YT", "Mayotte", "Mayotte", "Mayotte"],
  ["MX", "Mexico", "Mexique", "Mexico"],
  ["FM", "Micronesia", "Micronésie", "Micronesia"],
  ["MD", "Moldova", "Moldavie", "Moldavië"],
  ["MC", "Monaco", "Monaco", "Monaco"],
  ["MN", "Mongolia", "Mongolie", "Mongolië"],
  ["ME", "Montenegro", "Monténégro", "Montenegro"],
  ["MS", "Montserrat", "Montserrat", "Montserrat"],
  ["MA", "Morocco", "Maroc", "Marokko"],
  ["MZ", "Mozambique", "Mozambique", "Mozambique"],
  ["MM", "Myanmar (Burma)", "Myanmar (Birmanie)", "Myanmar (Birma)"],
  ["NA", "Namibia", "Namibie", "Namibië"],
  ["NR", "Nauru", "Nauru", "Nauru"],
  ["NP", "Nepal", "Népal", "Nepal"],
  ["NL", "Netherlands", "Pays-Bas", "Nederland"],
  ["NC", "New Caledonia", "Nouvelle-Calédonie", "Nieuw-Caledonië"],
  ["NZ", "New Zealand", "Nouvelle-Zélande", "Nieuw-Zeeland"],
  ["NI", "Nicaragua", "Nicaragua", "Nicaragua"],
  ["NE", "Niger", "Niger", "Niger"],
  ["NG", "Nigeria", "Nigeria", "Nigeria"],
  ["NU", "Niue", "Niue", "Niue"],
  ["NF", "Norfolk Island", "Île Norfolk", "Norfolk"],
  ["KP", "North Korea", "Corée du Nord", "Noord-Korea"],
  ["MK", "North Macedonia", "Macédoine du Nord", "Noord-Macedonië"],
  ["MP", "Northern Mariana Islands", "Îles Mariannes du Nord", "Noordelijke Marianen"],
  ["NO", "Norway", "Norvège", "Noorwegen"],
  ["OM", "Oman", "Oman", "Oman"],
  ["PK", "Pakistan", "Pakistan", "Pakistan"],
  ["PW", "Palau", "Palaos", "Palau"],
  ["PS", "Palestinian Territories", "Territoires palestiniens", "Palestijnse gebieden"],
  ["PA", "Panama", "Panama", "Panama"],
  ["PG", "Papua New Guinea", "Papouasie-Nouvelle-Guinée", "Papoea-Nieuw-Guinea"],
  ["PY", "Paraguay", "Paraguay", "Paraguay"],
  ["PE", "Peru", "Pérou", "Peru"],
  ["PH", "Philippines", "Philippines", "Filipijnen"],
  ["PN", "Pitcairn Islands", "Îles Pitcairn", "Pitcairneilanden"],
  ["PL", "Poland", "Pologne", "Polen"],
  ["PT", "Portugal", "Portugal", "Portugal"],
  ["PR", "Puerto Rico", "Porto Rico", "Puerto Rico"],
  ["QA", "Qatar", "Qatar", "Qatar"],
  ["RE", "Réunion", "La Réunion", "Réunion"],
  ["RO", "Romania", "Roumanie", "Roemenië"],
  ["RU", "Russia", "Russie", "Rusland"],
  ["RW", "Rwanda", "Rwanda", "Rwanda"],
  ["WS", "Samoa", "Samoa", "Samoa"],
  ["SM", "San Marino", "Saint-Marin", "San Marino"],
  ["ST", "São Tomé & Príncipe", "Sao Tomé-et-Principe", "Sao Tomé en Principe"],
  ["SA", "Saudi Arabia", "Arabie saoudite", "Saoedi-Arabië"],
  ["SN", "Senegal", "Sénégal", "Senegal"],
  ["RS", "Serbia", "Serbie", "Servië"],
  ["SC", "Seychelles", "Seychelles", "Seychellen"],
  ["SL", "Sierra Leone", "Sierra Leone", "Sierra Leone"],
  ["SG", "Singapore", "Singapour", "Singapore"],
  ["SX", "Sint Maarten", "Saint-Martin (partie néerlandaise)", "Sint-Maarten"],
  ["SK", "Slovakia", "Slovaquie", "Slowakije"],
  ["SI", "Slovenia", "Slovénie", "Slovenië"],
  ["SB", "Solomon Islands", "Îles Salomon", "Salomonseilanden"],
  ["SO", "Somalia", "Somalie", "Somalië"],
  ["ZA", "South Africa", "Afrique du Sud", "Zuid-Afrika"],
  ["GS", "South Georgia & South Sandwich Islands", "Géorgie du Sud-et-les Îles Sandwich du Sud", "Zuid-Georgia en Zuidelijke Sandwicheilanden"],
  ["KR", "South Korea", "Corée du Sud", "Zuid-Korea"],
  ["SS", "South Sudan", "Soudan du Sud", "Zuid-Soedan"],
  ["ES", "Spain", "Espagne", "Spanje"],
  ["LK", "Sri Lanka", "Sri Lanka", "Sri Lanka"],
  ["BL", "St. Barthélemy", "Saint-Barthélemy", "Saint-Barthélemy"],
  ["SH", "St. Helena", "Sainte-Hélène", "Sint-Helena"],
  ["KN", "St. Kitts & Nevis", "Saint-Christophe-et-Niévès", "Saint Kitts en Nevis"],
  ["LC", "St. Lucia", "Sainte-Lucie", "Saint Lucia"],
  ["MF", "St. Martin", "Saint-Martin", "Saint-Martin"],
  ["PM", "St. Pierre & Miquelon", "Saint-Pierre-et-Miquelon", "Saint-Pierre en Miquelon"],
  ["VC", "St. Vincent & Grenadines", "Saint-Vincent-et-les Grenadines", "Saint Vincent en de Grenadines"],
  ["SD", "Sudan", "Soudan", "Soedan"],
  ["SR", "Suriname", "Suriname", "Suriname"],
  ["SJ", "Svalbard & Jan Mayen", "Svalbard et Jan Mayen", "Spitsbergen en Jan Mayen"],
  ["SE", "Sweden", "Suède", "Zweden"],
  ["CH", "Switzerland", "Suisse", "Zwitserland"],
  ["SY", "Syria", "Syrie", "Syrië"],
  ["TW", "Taiwan", "Taïwan", "Taiwan"],
  ["TJ", "Tajikistan", "Tadjikistan", "Tadzjikistan"],
  ["TZ", "Tanzania", "Tanzanie", "Tanzania"],
  ["TH", "Thailand", "Thaïlande", "Thailand"],
  ["TL", "Timor-Leste", "Timor oriental", "Oost-Timor"],
  ["TG", "Togo", "Togo", "Togo"],
  ["TK", "Tokelau", "Tokelau", "Tokelau"],
  ["TO", "Tonga", "Tonga", "Tonga"],
  ["TT", "Trinidad & Tobago", "Trinité-et-Tobago", "Trinidad en Tobago"],
  ["TN", "Tunisia", "Tunisie", "Tunesië"],
  ["TR", "Türkiye", "Turquie", "Turkije"],
  ["TM", "Turkmenistan", "Turkménistan", "Turkmenistan"],
  ["TC", "Turks & Caicos Islands", "Îles Turques-et-Caïques", "Turks- en Caicoseilanden"],
  ["TV", "Tuvalu", "Tuvalu", "Tuvalu"],
  ["UM", "U.S. Outlying Islands", "Îles mineures éloignées des États-Unis", "Kleine afgelegen eilanden van de Verenigde Staten"],
  ["VI", "U.S. Virgin Islands", "Îles Vierges des États-Unis", "Amerikaanse Maagdeneilanden"],
  ["UG", "Uganda", "Ouganda", "Oeganda"],
  ["UA", "Ukraine", "Ukraine", "Oekraïne"],
  ["AE", "United Arab Emirates", "Émirats arabes unis", "Verenigde Arabische Emiraten"],
  ["GB", "United Kingdom", "Royaume-Uni", "Verenigd Koninkrijk"],
  ["US", "United States", "États-Unis", "Verenigde Staten"],
  ["UY", "Uruguay", "Uruguay", "Uruguay"],
  ["UZ", "Uzbekistan", "Ouzbékistan", "Oezbekistan"],
  ["VU", "Vanuatu", "Vanuatu", "Vanuatu"],
  ["VA", "Vatican City", "État de la Cité du Vatican", "Vaticaanstad"],
  ["VE", "Venezuela", "Venezuela", "Venezuela"],
  ["VN", "Vietnam", "Viêt Nam", "Vietnam"],
  ["WF", "Wallis & Futuna", "Wallis-et-Futuna", "Wallis en Futuna"],
  ["EH", "Western Sahara", "Sahara occidental", "Westelijke Sahara"],
  ["YE", "Yemen", "Yémen", "Jemen"],
  ["ZM", "Zambia", "Zambie", "Zambia"],
  ["ZW", "Zimbabwe", "Zimbabwe", "Zimbabwe"],
];

// The one non-ISO entry, and it is deliberate. `other` predates this slice, is
// held by live rows, and dropping it would orphan them for tidiness — the exact
// failure this slice exists to prevent. It is a firm's escape hatch, not a
// country, so it sorts last rather than under O.
export const COUNTRY_OTHER = ['other', 'Other', 'Autre', 'Andere'];
